import firebase from "firebase/app";

const state = {
  games: {},
  game: {},
  error: null
};

const getters = {
  getGames(state) {
    return state.games;
  },
  getGame(state) {
    return state.game;
  },
  getGameError(state) {
    return state.error;
  }
};

const mutations = {
  setGames(state, payload) {
    state.games = payload;
  },
  setGame(state, payload) {
    state.game = payload;
  },
  setError(state, payload) {
    state.error = payload;
  }
};

const actions = {
  async fetchGames({ commit }) {
    return await firebase
      .database()
      .ref(`/games`)
      .once("value", snapshot => {
        const games = snapshot.val() || {};
        commit(
          "setGames",
          Object.keys(games).map(key => ({ ...games[key], id: key }))
        );
      })
      .catch(error => {
        commit("setError", error);
      });
  }
};
export default {
  state,
  mutations,
  actions,
  getters
};
